import { List } from '@msdk/ui'
import { styled } from '@msdk/ui'

export const SidebarList = styled(List)`
  width: 100%;
  padding: 0 12px;
  display: flex;
  flex-flow: column wrap;
  margin: 0;
  gap: 0;
`
